import SplitHero from '@/components/blocks/hero_content/split_hero/SplitHero';
import LogoHeadline from '@/components/blocks/hero_content/logo_headline/LogoHeadline';
import TextAndButton from '@/components/blocks/hero_content/text_and_button/TextAndButton';
import FullImage from '@/components/blocks/hero_content/full_image/FullImage';

export default async function HeroContent({ block, position }) {
  if (!block?.hero_content?.reference?.[0]) {
    console.error('No hero content reference found!', position);
    return null;
  }

  const { modular_blocks, uid } = block.hero_content.reference[0];

  return modular_blocks?.map((item, index) => {
    switch (Object.keys(item)[0]) {
      case 'logo_headline':
        return (
          <LogoHeadline
            key={index}
            block={item}
            position={position}
            entry_uid={uid}
          />
        );
      case 'split_hero':
        return (
          <SplitHero
            key={index}
            block={item}
            position={position}
            entry_uid={uid}
          />
        );
      case 'text_and_button':
        return (
          <TextAndButton
            key={index}
            block={item}
            position={position}
            entry_uid={uid}
          />
        );
      case 'full_image':
        return (
          <FullImage
            key={index}
            block={item}
            position={position}
            entry_uid={uid}
          />
        );
      default:
        return <div key={index} className="empty-component"></div>;
    }
  });
}
